import { createFileRoute } from "@tanstack/react-router";
import ShowroomConfigure from "lib/components/showroom2/pages/ShowroomConfigure";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../components/withAuthentication";

/**
 * Editor for a saved `HomePlan`. Loads from the `home-plans/base-data` API
 * and is the flow CTA submissions funnel into — editable for single-unit
 * plans, read-only overview for multi-unit. Gated on `showroomUnification`.
 */
function ShowroomPlan() {
  const { homePlanId, builderId } = useAppRouterParams();
  const showroomKey = [builderId, homePlanId].filter(Boolean).join("-") || undefined;

  return (
    <ShowroomProvider key={showroomKey} version="sales">
      <ShowroomConfigure />
    </ShowroomProvider>
  );
}

export const Route = createFileRoute("/showroom/plan/$home_plan_id/")({
  component: withAuthentication(ShowroomPlan, {
    features: ["showroomUnification"],
    permissions: ["VIEW_HOME_PLANS"],
    products: ["showroom"],
  }),
});
